import { makeStyles } from '@eagleview/ev-comp-library';
import { INFO, ERROR, SUCCESS } from 'constants/AppConstants';

export default makeStyles((theme) => ({
  accountsSummaryPaper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'fit-content',
    borderRadius: 0,
    boxShadow: 'none',
    '@media (min-width: 790px)': {
      width: '40%',
      height: 'fit-content',
      borderRadius: 4,
      boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 3px 0px rgba(0,0,0,0.12)',
      minWidth: '410px',
      '@media (min-width: 1200px)': {
        width: '30%',
        height: 'auto',
      },
    },
  },
  topSection: {
    display: 'flex',
    flexDirection: 'row',
    padding: '24px',
    width: '100%',
    gap: '16px',
    borderBottom: `1px solid ${theme.evPalette.charcoal[400]}`,
  },
  companyNameSection: {
    gap: '10px',
    width: '100%',
  },
  companyTitleText: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '24px',
    textTransform: 'capitalize',
  },
  companyAddressText: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px',
  },
  editOutlineButton: {
    alignSelf: 'start',
    textAlign: 'center',
    boxSizing: 'border-box',
    width: '48px',
    height: '32px',
    border: `1px solid ${theme.evPalette.ocean[500]}`,
    borderRadius: '4px',
    backgroundColor: theme.evPalette.salt[100],
  },
  bottomSection: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px',
    width: '100%',
    gap: '16px',
  },
  accountsSummaryText: {
    fontSize: '18px',
    fontWeight: '400',
    lineHeight: '27px',
    color: theme.evPalette.charcoal[900],
    '@media (min-width: 790px)': {
      fontSize: '24px',
      lineHeight: '36px',
    },
  },
  orderDetailsContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    gap: '8px',
    justifyContent: 'space-between',
  },
  orderDetailsBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '25%',
  },
  orderDetailsTitleText: {
    color: theme.evPalette.charcoal[700],
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '21px',
  },
  orderDetailsValueText: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
  },
  membershipLevelContainer: {
    display: 'flex',
    flexDirection: 'column',
    radius: '4px',
    padding: '16px',
    width: '100%',
    gap: '24px',
    backgroundColor: theme.evPalette.charcoal[100],
  },
  membershipLevelText: {
    color: theme.evPalette.charcoal[700],
    fontFamily: 'Noto Sans',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '27px',
  },
  membershipLevelTopContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: '8px',
  },
  membershipLevelLink: {
    color: theme.evPalette.ocean[600],
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    textDecoration: 'underline',
    fontWeight: 400,
    lineHeight: '24px',
    textAlign: 'left',
    margin: 'auto 0px auto 0px',
    '@media (max-width: 790px)': {
      marginLeft: '0px',
    },
  },
  upgradeButton: {
    height: '44px',
    width: '60%',
    minWidth: '210px',
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '22px',
    backgroundColor: theme.evPalette.salt[100],
  },
  yearsSummaryContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: '8px',
  },
  yearToDateText: {
    color: theme.evPalette.charcoal[700],
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '24px',
  },
  yearsSummaryContentContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    gap: '8px',
    justifyContent: 'space-between',
  },
  yearsSummaryContentElement: {
    display: 'flex',
    flexDirection: 'column',
    width: '25%',
    justifyContent: 'flex-end',
    '&.negativeBalance': {
      justifyContent: 'center',
    },
  },
  lastDepositAlertContainer: {
    borderRadius: '4px',
    padding: '16px',
    gap: '4px',
    [`&.${SUCCESS}`]: {
      backgroundColor: theme.evPalette.lime[100],
      '& svg': { color: theme.evPalette.lime[700] },
    },
    [`&.${ERROR}`]: {
      backgroundColor: theme.evPalette.rose[100],
      '& svg': { color: theme.evPalette.rose[900] },
    },
    [`&.${INFO}`]: {
      backgroundColor: theme.evPalette.ocean[100],
      '& svg': { color: theme.evPalette.ocean[600] },
    },
    '&>.myev-MuiAlert-message': {
      padding: '0px',
      fontSize: '16px',
      lineHeight: '24px',
      color: theme.evPalette.charcoal[900],
      display: 'flex',
      flexDirection: 'column',
    },
    '&>.myev-MuiAlert-icon': {
      padding: '4px 0px',
    },
    '&>.myev-MuiAlert-action ': {
      alignItems: 'flex-start',
    },
  },
  alertErrorLink: {
    fontSize: '16px',
    fontStyle: 'normal',
    textDecoration: 'underline',
    fontWeight: 400,
    lineHeight: '24px',
  },
}));
